module.exports = __webpack_public_path__ + "img/switch.e7c5f7c9.svg";